/* eslint-disable @typescript-eslint/no-unused-vars */

import { ReactComponent as ConffetiHornIcon } from "assets/club-gifts-galore/svg/ConffetiHorn.svg";
import { SectionIconContainer, SectionTitle } from "styles/general_styles";
import { useAppSelector, usePopupsState } from "hooks";
import { selectDipState } from "redux/slices";
import { ClubGiftsGaloreResponse } from "interfaces/club-gifts-galore-v2";
import { offersApi, useGetFeatureTrackerQuery } from "redux/apis";
import { FeatureType } from "interfaces/feature-tracker";
import { useWebStoreContext } from "contexts";
import { useEffect } from "react";
import { GiftsGaloreCard } from "./lib/GiftsGaloreCard";
import { orderBy } from "lodash";

const ClubEventSectionV2 = () => {
	const { store, authToken } = useWebStoreContext();
	const { currentDip: dipVariant, triggerCached } =
		useAppSelector(selectDipState);
	const { isAnyPopupOpen } = usePopupsState();
	const isPopupsOpen = !!(
		isAnyPopupOpen ||
		dipVariant ||
		triggerCached === "sessionStart"
	);
	const {
		data,
		isLoading,
		refetch
	}: {
		data?: ClubGiftsGaloreResponse;
		isLoading: boolean;
		refetch: () => void;
	} = useGetFeatureTrackerQuery(
		{
			FeatureType: FeatureType.CLUB_GIFT_BONUS_V2,
			isAuthenticated: !!authToken?.value
		},
		{
			refetchOnFocus: !isPopupsOpen,
			pollingInterval: !isPopupsOpen ? 10000 : undefined,
			skip: !authToken?.value
		}
	);

	const { data: boxesData, isLoading: isBoxesLoading } =
		offersApi.endpoints.getOffers.useQueryState({
			offerType: "clubGift",
			isAuthenticated: !!authToken?.value
		});

	const orderedOffers = orderBy(boxesData?.offers, ["priority"], ["asc"]);

	const giftBox = store?.clubGifts?.find(
		(gift) => gift.id === orderedOffers?.[0]?.id
	);

	// *Refetch when popups are closed
	useEffect(() => {
		if (!isPopupsOpen) {
			refetch();
		}
	}, [isPopupsOpen]);

	if (isLoading || isBoxesLoading) {
		//Show loader here
		return null;
	}

	if (!data?.tracker) {
		return null;
	}

	return (
		<>
			<SectionTitle>
				<SectionIconContainer>
					<ConffetiHornIcon width="21px" height="40px" />
				</SectionIconContainer>
				<div>CLUB EVENT</div>
			</SectionTitle>
			<GiftsGaloreCard
				tracker={data.tracker}
				refetch={refetch}
				isPopupsOpen={isPopupsOpen}
				giftBox={giftBox}
			/>
		</>
	);
};

export default ClubEventSectionV2;
